import React, { Component } from 'react'
import TextField from 'material-ui/TextField';
import EntityEdit from '../../components/entityEdit';
import EntitySelector from './../../components/entitySelector';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import {GridList, GridTile} from 'material-ui/GridList';
import DaggableImagesContainer from '../../components/draggableImagesContainer';

import utils from '../../misc/utils';
var config = utils.getConfig();

import DeleteIcon from 'material-ui/svg-icons/action/delete';

const Styles = {
  content: {
    marginTop: 10,
    marginBottom: 5
  },
  control: {
    marginLeft: 20
  },
  dialogContentStyle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1280px',
    maxWidth: 'none'
  }
};

class QuoteEdit extends EntityEdit {
  constructor(props, context) {
    super(props, context);

    this.onQuotesSelectorButtonClick = this.onQuotesSelectorButtonClick.bind(this);
    this.onTrailersSelectorButtonClick = this.onTrailersSelectorButtonClick.bind(this);
    this.onQuotesSelected = this.onQuotesSelected.bind(this);
    this.onTrailersSelected = this.onTrailersSelected.bind(this);
    this.copyFromEntity = this.copyFromEntity.bind(this);
    this.addPicture = this.addPicture.bind(this);
    this.onImageFileSelected = this.onImageFileSelected.bind(this);

    this.state.isQuotesSelectorOpened = false;
    this.state.isTrailersSelectorOpened = false;
  }

  onQuotesSelectorButtonClick(){
    this.setState({
      isQuotesSelectorOpened: true,
    });
  }

  onTrailersSelectorButtonClick(){
    this.setState({
      isTrailersSelectorOpened: true,
    });
  }

  onQuotesSelected(accepted){
    if(accepted){
      var selector = this.refs['QuotesSelector'];
      var entity = selector.state.selectedEntity;
      this.copyFromEntity(entity, 'quotes');
    }

    this.setState({
      isQuotesSelectorOpened: false,
    });
  }

  onTrailersSelected(accepted){
    if(accepted){
      var selector = this.refs['TrailersSelector'];
      var entity = selector.state.selectedEntity;
      this.copyFromEntity(entity, 'trailers');
    }

    this.setState({
      isTrailersSelectorOpened: false,
    });
  }

  copyFromEntity(entity, imagesRoute){
    Object.keys(entity).map((propertyName) => {
      if(propertyName !== 'ID'){
        this.state.currentEntity[propertyName] = entity[propertyName];
      }
    });
    this.initSelectFieldsDataSources(this.state.fields);

    var utils = require('../../misc/utils');
    utils.default.getDataFromApi('api/' + imagesRoute + '/' + entity.ID + '/images', (results) => {
      while(this.state.currentEntity.Images.length)
        this.state.currentEntity.Images.pop();

      results.forEach((image) => {
        image.ID = image.ImageName;
        image.State = 'added';
        image.Imported = true;
        this.state.currentEntity.Images.push(image);
      });

      this.setState({
        currentEntity: this.state.currentEntity
      });
    }, null);
  }

  addPicture(){
    this.refs['AddPictureInput'].click();
  }

  onImageFileSelected(e){
    var utils = require('../../misc/utils');

    for(var i = 0; i < e.target.files.length; i++){
      var formData = new FormData();
      formData.append('type', 'file');
      formData.append('image', e.target.files[i]);

      utils.default.uploadFileToApi('api/images', formData, (result) => {
        this.state.currentEntity.Images.push({ID: result.Name, ImageName: result.Name, State: 'added'});
        this.setState({
          currentEntity: this.state.currentEntity
        });
      }, null, true);
    }
  }

  componentDidMount(){
    var utils = require('../../misc/utils');

    if(this.state.isNew){
      this.state.currentEntity.Year = new Date().getFullYear();

      utils.default.fetchCurrentUser((user) =>{
        if(user){
          var entity = this.state.currentEntity;
          entity.PreparedByUserID = user.ID;
          entity.User = user;
          entity.DateValue = new Date().toISOString().slice(0,10).replace('-', '').replace('-', '');
          entity.Images = [];

          EntityEdit.prototype.componentDidMount.call(this);
        }
      });
    }
    else{
      EntityEdit.prototype.componentDidMount.call(this);

      utils.default.getDataFromApi('api/quotes/' + this.state.currentEntity.ID + '/images', (results) => {
        this.state.currentEntity.Images = results;
        this.setState({
          currentEntity: this.state.currentEntity
        });
      }, null);
    }
  }

  render() {
    if(this.state.fields){
      return (
        <div style={Styles.content}>
          <div>
            <Dialog
              contentStyle={Styles.dialogContentStyle}
              autoScrollBodyContent={true}
              open={this.state.isQuotesSelectorOpened}
              actions={
                [
                  <FlatButton
                    label="Annuler"
                    primary={true}
                    onTouchTap={() => this.onQuotesSelected(false)}
                  />,
                  <FlatButton
                    label="Ok"
                    primary={true}
                    keyboardFocused={true}
                    onTouchTap={() => this.onQuotesSelected(true)}
                  />,
                ]
              }>
              <EntitySelector ref='QuotesSelector' apiRoute='api/quotes' title='Sélectionner une soumission' defaultOrderBy='-ID' displayColumns={[
                {Description: '#', Column: 'ID'},
                {Description: 'Client', Column: 'CustomerName'},
                {Description: 'Compagnie', Column: 'Company'},
                {Description: 'Préparé par', Column: 'User', format: {type: 'relation', displayColumn: 'Name'}},
                {Description: 'Envoyé le', Column: 'SentDateValue', format: {type: 'datetime'}},
              ]}/>
            </Dialog>
            <Dialog
              contentStyle={Styles.dialogContentStyle}
              autoScrollBodyContent={true}
              open={this.state.isTrailersSelectorOpened}
              actions={
                [
                  <FlatButton
                    label="Annuler"
                    primary={true}
                    onTouchTap={() => this.onTrailersSelected(false)}
                  />,
                  <FlatButton
                    label="Ok"
                    primary={true}
                    keyboardFocused={true}
                    onTouchTap={() => this.onTrailersSelected(true)}
                  />,
                ]
              }>
              <EntitySelector ref='TrailersSelector' apiRoute='api/trailers' title='Sélectionner une remorque' displayColumns={[
                {Description: 'No. inventaire', Column: 'ProductNumber'},
                {Description: 'No. modèle', Column: 'ModelNumber'},
                {Description: 'Modèle', Column: 'TrailerModel', format: {type: 'relation', displayColumn: 'Description'}},
                {Description: 'État', Column: 'State', format: {type: 'relation', displayColumn: 'Description'}},
                {Description: 'Marque', Column: 'Make', format: {type: 'relation', displayColumn: 'Description'}},
                {Description: 'Année', Column: 'Year'},
                {Description: 'Prix', Column: 'Price', format: {type: 'money'}},
              ]}/>
            </Dialog>
          </div>
          <div>
            <style>
              {`
                td{
                  vertical-align: top;
                }
              `}
            </style>
            <div style={{marginBottom: 15}}>
              <strong style={{marginRight: 20}}>IMPORTER</strong>
              <FlatButton label='Remorque' onTouchTap={this.onTrailersSelectorButtonClick}/>
              <FlatButton label='Soumission' onTouchTap={this.onQuotesSelectorButtonClick}/>
            </div>
            <table>
              <colgroup>
                <col style={{width: '33%'}} />
                <col style={{width: '33%'}} />
                <col style={{width: '33%'}} />
              </colgroup>
              <tbody>
                <tr>
                  <td><strong>Coordonnées du client</strong></td>
                  <td></td>
                  <td><strong>Soumission #{this.state.currentEntity.ID}</strong></td>
                </tr>
                <tr>
                  <td><form>{this.getComponentFromFieldDef('CustomerName', this.state.fields.CustomerName, undefined, undefined, {id: 'customerName', autoComplete: 'on'})}</form></td>
                  <td>{this.getComponentFromFieldDef('Company', this.state.fields.Company)}</td>
                  <td>{this.getComponentFromFieldDef('DateValue', this.state.fields.DateValue)}</td>
                </tr>
                <tr>
                  <td><form>{this.getComponentFromFieldDef('CustomerPhoneNumber', this.state.fields.CustomerPhoneNumber, undefined, undefined, {id: 'customerPhoneNumber', type: 'tel', autoComplete: 'on'})}</form></td>
                  <td><form>{this.getComponentFromFieldDef('CustomerEmail', this.state.fields.CustomerEmail, undefined, undefined, {id: 'customerEmailAddress', type: 'email', autoComplete: 'on'})}</form></td>
                  <td>{this.getComponentFromFieldDef('PreparedByUserID', this.state.fields.PreparedByUserID)}</td>
                </tr>
                <tr>
                  <td colSpan={3}>{this.getComponentFromFieldDef('Comments', this.state.fields.Comments)}</td>
                </tr>
                <tr>
                  <td><strong>Description de la remorque</strong></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('ProductNumber', this.state.fields.ProductNumber)}</td>
                  <td>{this.getComponentFromFieldDef('MakeID', this.state.fields.MakeID)}</td>
                  <td>{this.getComponentFromFieldDef('ModelNumber', this.state.fields.ModelNumber)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('Year', this.state.fields.Year)}</td>
                  <td>
                    {this.getComponentFromFieldDef('WidthID', this.state.fields.WidthID, 65, 'L')}
                    {this.getComponentFromFieldDef('LengthID', this.state.fields.LengthID, 65, 'l')}
                    {this.getComponentFromFieldDef('HeightID', this.state.fields.HeightID, 65 , 'H')}
                  </td>
                  <td>{this.getComponentFromFieldDef('ModelID', this.state.fields.ModelID)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('StateID', this.state.fields.StateID)}</td>
                  <td>{this.getComponentFromFieldDef('ChargeCapacity', this.state.fields.ChargeCapacity)}</td>
                  <td>{this.getComponentFromFieldDef('Weight', this.state.fields.Weight )}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('WarantyID', this.state.fields.WarantyID)}</td>
                  <td>{this.getComponentFromFieldDef('WeightValidation', this.state.fields.WeightValidation)}</td>
                  <td>{this.getComponentFromFieldDef('DimensionText', this.state.fields.DimensionText)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('ColorID', this.state.fields.ColorID)}</td>
                  <td>{this.getComponentFromFieldDef('SuspensionTypeID', this.state.fields.SuspensionTypeID)}</td>
                  <td>{this.getComponentFromFieldDef('AxleNumberID', this.state.fields.AxleNumberID)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('TieTypeID', this.state.fields.TieTypeID)}</td>
                  <td>{this.getComponentFromFieldDef('WheelID', this.state.fields.WheelID)}</td>
                  <td>{this.getComponentFromFieldDef('BreakTypeID', this.state.fields.BreakTypeID)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('FrontID', this.state.fields.FrontID)}</td>
                  <td>{this.getComponentFromFieldDef('SideDoorID', this.state.fields.SideDoorID)}</td>
                  <td>{this.getComponentFromFieldDef('BackDoorID', this.state.fields.BackDoorID)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('LightID', this.state.fields.LightID)}</td>
                  <td>{this.getComponentFromFieldDef('StoneShieldID', this.state.fields.StoneShieldID)}</td>
                  <td>{this.getComponentFromFieldDef('CorrosionShieldID', this.state.fields.CorrosionShieldID)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('RoofID', this.state.fields.RoofID)}</td>
                  <td>{this.getComponentFromFieldDef('WallID', this.state.fields.WallID)}</td>
                  <td>{this.getComponentFromFieldDef('FloorID', this.state.fields.FloorID)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('RoofStructureID', this.state.fields.RoofStructureID)}</td>
                  <td>{this.getComponentFromFieldDef('WallStructureID', this.state.fields.WallStructureID)}</td>
                  <td>{this.getComponentFromFieldDef('FloorStructureID', this.state.fields.FloorStructureID)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('StandardHardwareID', this.state.fields.StandardHardwareID)}</td>
                  <td>{this.getComponentFromFieldDef('DoorRestraintID', this.state.fields.DoorRestraintID)}</td>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan={3}>{this.getComponentFromFieldDef('Various', this.state.fields.Various)}</td>
                </tr>
                <tr>
                  <td colSpan={3}>{this.getComponentFromFieldDef('TrailerOption', this.state.fields.TrailerOption)}</td>
                </tr>
                <tr>
                  <td colSpan={3}>{this.getComponentFromFieldDef('Notes', this.state.fields.Notes)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('Cost', this.state.fields.Cost)}</td>
                  <td>{this.getComponentFromFieldDef('TransportCost', this.state.fields.TransportCost)}</td>
                  <td>{this.getComponentFromFieldDef('ExchangeRate', this.state.fields.ExchangeRate)}</td>
                </tr>
                <tr>
                  <td>{this.getComponentFromFieldDef('Price', this.state.fields.Price)}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div style={{margin:20}}>
                      {
                        this.state.currentEntity.Images &&
                        <DaggableImagesContainer images={this.state.currentEntity.Images}/>
                      }
                      <div style={{textAlign: 'center', margin: '10px'}}>
                        <FlatButton
                          label='Ajouter des photos'
                          onTouchTap={this.addPicture}>
                          <input ref='AddPictureInput' name='image' type='file' id='imageButton' accept='image/*' style={{display: 'none'}} onChange={this.onImageFileSelected} multiple></input>
                        </FlatButton>
                      </div>
                    </div>
                  </td>
                  <td>
                    {this.getComponentFromFieldDef('InStock', this.state.fields.InStock)}
                    {this.getComponentFromFieldDef('WeeksBeforeManufacture', this.state.fields.WeeksBeforeManufacture)}
                    {this.getComponentFromFieldDef('WeeksBeforeDelivery', this.state.fields.WeeksBeforeDelivery)}
                  </td>
                  <td>
                    {this.getComponentFromFieldDef('Waiting', this.state.fields.Waiting)}
                    {this.getComponentFromFieldDef('Accepted', this.state.fields.Accepted)}
                    {this.getComponentFromFieldDef('Refused', this.state.fields.Refused)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )
    }
    else
      return (<div></div>);
  }
}

export default QuoteEdit;


/** WEBPACK FOOTER **
 ** ./src/app/routes/quotes/quoteEdit.js
 **/